var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTidal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "286px",
    height: "286px",
    viewBox: "0 0 286 286",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "tidal") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tidal"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#000000",
    cx: 146,
    cy: 143,
    r: 140
  }), /*#__PURE__*/React.createElement("g", {
    id: "Tidal",
    transform: "translate(62.000000, 96.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    stroke: "#000000",
    strokeWidth: 0.50999999
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.9582229,56.5918934 L84.5670278,56.4171249 C75.3753719,65.6796429 66.1401963,74.8984543 56.948579,84.1172802 L56.948579,84.11729 C56.8614622,84.2920488 56.7743454,84.5542015 56.6872093,84.7289604 C63.0037201,90.9767845 69.2331141,97.2683056 75.5052166,103.559807 C78.5990036,106.530804 81.5176685,109.763954 84.6977031,112.647557 C86.9185255,110.681464 89.0095031,108.322138 91.187617,106.224964 C97.8962115,99.5402285 104.605637,92.7681085 111.313323,86.0833824 C111.793412,85.5153896 112.446808,85.122175 112.750886,84.4231203 C103.428613,75.2042944 94.1934179,65.8981036 84.9582229,56.5918934 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6541253,56.3734328 C93.6715282,47.3730676 102.646184,38.3290247 111.662679,29.328657 C112.054763,28.9354303 112.533925,28.5859126 112.751736,28.0616119 C103.648124,19.1486285 94.7605852,10.0608935 85.7431822,1.10421822 C85.3946763,0.754684022 85.1341757,0.405165246 84.8719367,0.0119392118 L84.5234501,0.0119392118 C75.3317942,9.53659126 65.7045735,18.7554178 56.5564954,28.3237625 C66.0095017,37.5862803 75.2446967,47.067242 84.6541253,56.3734328 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4258201,28.3674544 L56.4258201,28.0179198 L37.1713208,8.70646412 C34.3397728,5.77916179 31.3348411,3.07031767 28.6766961,0.0119401006 L28.3282095,0.0119401006 C19.8335655,8.75015563 11.1211295,17.3136051 2.53936862,26.0081291 C1.84237603,26.7508904 0.928441313,27.3625584 0.448390927,28.2800713 C9.81426117,37.6299566 19.1365923,47.023551 28.5024625,56.373434 C37.8247549,47.067242 47.1043775,37.6736476 56.4258201,28.3674544 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.857939,27.0567147 C160.801746,19.9787559 153.787354,12.9445037 146.730273,5.86654361 C144.857088,3.90044474 142.809668,2.10911294 141.067177,0.0119388944 L140.718671,0.0119388944 C136.188249,4.77426524 131.483476,9.31813211 126.865898,13.9930917 C122.161203,18.6680344 117.543586,23.4303601 112.795314,28.0616119 C113.013125,28.6732968 113.579442,29.0228145 114.015065,29.5034255 L140.805827,56.3734328 C150.302372,47.1546214 159.450412,37.5862802 168.903457,28.3674544 C168.773612,27.7994761 168.207295,27.4499415 167.857939,27.0567147 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTidal);
export default __webpack_public_path__ + "static/media/tidal.76af71cbb6f5f2b689156f76d7d53c4f.svg";
export { ForwardRef as ReactComponent };